import pluralize from "pluralize"
import {
  BLANK_PAYROLL_FEE_ITEM,
  BLANK_PAYROLL_PLACEMENT_FEE_ITEM,
  BLANK_PLACEMENT_FEE_ITEM,
} from "../../../internal/subscription/helpers/plans"
import { v4 as uuidv4 } from "uuid"

const TALENT_SEARCH_PLANS = [
  {
    planType: "Talent Search",
    planName: "Starter",
    tagLine: "Quick start to quality hiring",
    rate: 12 + 2,
    rateType: "percentage",
    determinant: "of annual salary based on 13 months salary",
    paymentTermsInDays: 30,
    effectivePeriodInMonths: 24,
    terminationPeriodInDays: 30,
    items: [
      { label: "1 Month Guarantee Period", bold: true },
      { label: "30 Days Payment Term", bold: true },
      { label: "Full-fledged Recruitment" },
      { label: "Advisory on Market Insights" },
      { label: "Applicant Tracking System" },
    ],
    otherRates: {
      candidateOwnershipInMonths: 12,
      refundPolicy: null,
      refundPolicyOptions: {},
      placementFeeItems: [
        {
          ...BLANK_PLACEMENT_FEE_ITEM,
          uuid: uuidv4(),
          rate2: 12 + 2,
          description: "All",
          guaranteePeriodInMonths: 1,
        },
      ],
    },
  },
  {
    planType: "Talent Search",
    planName: "Plus",
    tagLine: "Hiring with better security",
    rate: 14 + 2,
    rateType: "percentage",
    determinant: "of annual salary based on 13 months salary",
    paymentTermsInDays: 45,
    effectivePeriodInMonths: 24,
    terminationPeriodInDays: 30,
    items: [
      { label: "2 Months Guarantee Period", bold: true },
      { label: "45 Days Payment Term", bold: true },
      { label: "Full-fledged Recruitment" },
      { label: "Advisory on Market Insights" },
      { label: "Applicant Tracking System" },
    ],
    otherRates: {
      candidateOwnershipInMonths: 12,
      refundPolicy: null,
      refundPolicyOptions: {},
      placementFeeItems: [
        {
          ...BLANK_PLACEMENT_FEE_ITEM,
          uuid: uuidv4(),
          rate2: 14 + 2,
          description: "All",
          guaranteePeriodInMonths: 2,
        },
      ],
    },
  },
  {
    planType: "Talent Search",
    planName: "Pro",
    tagLine: "Hiring with exceptional value",
    rate: 16 + 2,
    rateType: "percentage",
    determinant: "of annual salary based on 13 months salary",
    paymentTermsInDays: 60,
    effectivePeriodInMonths: 24,
    terminationPeriodInDays: 30,
    items: [
      { label: "3 Months Guarantee Period", bold: true },
      { label: "60 Days Payment Term", bold: true },
      { label: "Full-fledged Recruitment" },
      { label: "Advisory on Market Insights" },
      { label: "Applicant Tracking System" },
    ],
    otherRates: {
      candidateOwnershipInMonths: 12,
      refundPolicy: null,
      refundPolicyOptions: {},
      placementFeeItems: [
        {
          ...BLANK_PLACEMENT_FEE_ITEM,
          uuid: uuidv4(),
          rate2: 16 + 2,
          description: "All",
          guaranteePeriodInMonths: 3,
        },
      ],
    },
  },
]

const FULL_ENTITLEMENT =
  "<p><strong>Annual Leave Entitlement</strong></p> <p><br></p> <ul> <li>Fourteen (14) days of paid annual leave based on 12 months upon your completion of three (3) months of service from the date of your employment. Should the contract be terminated within three (3) months from the start of the employment, any leaves taken during these period shall be considered as unpaid. Annual leave entitlement will be in proportion to the number of completed months of service. Unconsumed Annual Leave may be carried forward for one (1) year only with a maximum of 12 days. Any Annual Leave which exceeds the one (1) year entitlement will be automatically forfeited. &nbsp;Please note that Annual Leave entitlement is granted only upon satisfying the following conditions:&nbsp; <ul> <li>Applicable to contractor who have served at least the minimum required period of eligibility from the date of employment (unless stated otherwise);</li> <li>This entitlement shall be of immediate effect to contractor during the renewal of contract (subject to completion of the minimum eligibility period) (if there is renewal contract); and</li> <li>Approval from superior must be sought for before going on annual leave.</li> </ul> </li> <li>No encashment of unconsumed annual leave is allowed without prior notice and approval.</li> </ul> <p><br></p> <p><br></p> <p><strong>Medical &amp; Hospitalisation Leave Entitlement</strong></p> <p><br></p> <ul> <li>The contractor with at least 3 months of service is entitled to 14 days working days of medical leave and 60 working days of hospitalisation leave &nbsp;(inclusive of 14 days of medical leave) per annum. The medical and hospitalisation leave entitlement for the 4th to 6th months of service will be phased in according to the employment act. Any medical and/or hospitalisation leave taken during the 1st three (3) months of your employment will be deemed as unpaid. There shall be non-proration of leave entitlement from the 6th month of service onwards. Such leave must be supported by medical certificate issued by the appointed Company in-house doctor, clinics under the medical service provider of Jobline, government polyclinics, and government-restructured hospitals. Please note that Medical and/or Hospitalisation &nbsp;Leave entitlement is granted only upon satisfying the following conditions:&nbsp; <ul> <li>Applicable to contractor who have served at least the minimum required period of eligibility from the date of employment (unless stated otherwise);</li> <li>This entitlement shall be of immediate effect to contractor during the renewal of contract (subject to completion of the minimum eligibility period) (if there is renewal contract);</li> <li>Has informed or attempted to inform the employer of his/her absence within 48 hours. Otherwise, the contractor will be deemed to be absent from work without permission or reasonable excuse; and</li> <li>Valid medical certificates must be produced or otherwise, leaves taken shall be considered as either unpaid or annual leaves at the sole discretion of the client</li> </ul> </li> </ul> <p><br></p> <p>Medical &amp; Hospitalisation certificates issued by overseas clinics and hospitals will not be recognised.</p> <p><br></p> <ul> <li>The contractor will be eligible to outpatient medical treatment with a co-payment scheme at panel clinics (E-medical card will be issued). Claims on Dental will not be allowed. &nbsp;Refer to insurance booklet for the coverage details.&nbsp;</li> </ul> <p><br></p> <p>This benefit is only applicable to contract with at least 3 months of contract with <company_name> or has been in service with no less than 3 months. Please note that this entitlement is granted only upon satisfying the following conditions:&nbsp;</p> <ol> <li>Applicable to contractor who have served at least the minimum required period of eligibility from the date of employment (unless stated otherwise);</li> <li>This entitlement shall be of immediate effect to contractor during the renewal of contract (subject to completion of the minimum eligibility period) (if there is renewal contract); and</li> <li>Supporting documents must be provided to AON (Jobline Insurance broker) for reimbursements. &nbsp;</li> <li>Approximately 8 weeks after your commencement date, you will receive a “Welcome Email” from our insurer and you may download the app for the e-Medical card.</li> <li>The e-Medical card usability will auto-cease on your last physical work day.&nbsp;</li> </ol> <p><br></p> <p><br></p> <p><strong>ProFamily Leaves</strong></p> <p><br></p> <p>Pro-Family leave schemes as per guidelines by the Government, &nbsp;based on each 12 months period contract. Contractor cannot use any of the ProFamily leave(s) to offset the notice period when they leave the job nor be used to supersede any other leave applied. Profamily leave(s) are non-cumulative and unconsumed leaves shall lapse at the end of each 12-month period. Supporting document are to be submitted to Jobline before any leave application. Please refer to the Employee Handbook for more details on contractor’s eligibility and application criteria.</p> <ul> <li>&nbsp;Government-Paid Child Care Leave (GPCL): 6 days of paid child care leave every contractual year (12-month period), for youngest child below 7 years old, with a minimum of 2 days per year (applicable for Parent of non-SC child).&nbsp;</li> <li>Extended Government-Paid Child Care Leave (GPCL) : 2 days of government-paid child care leave every contractual year (12-month period), for youngest child between 7 to 12 years old.</li> <li>Government-Paid Maternity Leave (GPML): Female contractor shall be entitled to maternity benefits as stipulated in Employment Act (if applicable)&nbsp;</li> <li>Government-Paid Paternity Benefits (GPPL) : 2 weeks of GPPL to be taken within 16 weeks after child’s birth.&nbsp;</li> <li>Government-Paid Shared Parental Leave (SPL): 4 weeks of spouse’s 16-week maternity leave to be taken in a continuous block within 12 months after child’s birth. This will apply for parents of citizen children born from 1 July 2017. If your citizen child is born before 1 July 2017, you will be entitled to 1 week of shared parental leave.&nbsp;</li> </ul> <p><br></p> <p><br></p> <p><strong>Suspension of Benefits</strong></p> <p><br></p> <p>All benefits entitlement (inclusive of medical insurance coverage) shall be suspended for contractors during his/her unpaid leave period.</p>"
const PAYROLL_MANAGED_SERVICES_PLANS = {
  plans: [
    {
      planType: "Payroll Managed Services",
      planName: "Custom",
      tagLine: null,
      rate: null,
      rateType: null,
      determinant: null,
      paymentTermsInDays: 30,
      otherRates: {
        guaranteePeriodInMonths: 1,
        payrollFeeItems: [
          {
            ...BLANK_PAYROLL_FEE_ITEM,
            uuid: uuidv4(),
          },
        ],
        statutoryChargesItems: [
          {
            itemName: "CPF",
            rate: "In accordance to the prevailing rate",
            billingCycle: "Monthly",
            fixedBillingCycle: true,
            placementType: "All",
            fixedPlacementType: true,
            fixedItem: true,
            uuid: uuidv4(),
          },
          {
            itemName: "SDL",
            rate: "In accordance to the prevailing rate",
            fixedBillingCycle: true,
            billingCycle: "Monthly",
            placementType: "All",
            uuid: uuidv4(),
          },
        ],
        workPassRelatedChargesItems: {
          include: true,
          items: [
            {
              uuid: uuidv4(),
              itemName: "Work Pass Levy",
              description: "S Pass",
              fixedDescription: true,
              rate: "As charged by MOM",
              fixedRate: true,
              determinant: null,
              billingCycle: "Monthly",
              fixedBillingCycle: true,
              placementType: "All",
              fixedPlacementType: true,
            },
            {
              uuid: uuidv4(),
              itemName: "Work Pass Application Costs",
              description:
                "Work Pass Application/Issuance fees, Medical Examination and any related costs",
              fixedDescription: true,
              rate: "As charged by MOM",
              fixedRate: true,
              determinant: null,
              billingCycle: "Per Application",
              fixedBillingCycle: false,
              placementType: null,
              fixedPlacementType: false,
            },
            {
              uuid: uuidv4(),
              itemName: "Work Pass Management Fee",
              description: null,
              rate: null,
              rateType: "Money",
              fixedRateType: true,
              determinant: null,
              billingCycle: "Monthly",
              fixedBillingCycle: true,
              placementType: null,
              fixedPlacementType: false,
            },
            {
              uuid: uuidv4(),
              itemName: "Work Pass Surcharge",
              description: "S Pass",
              fixedDescription: true,
              rate: null,
              rateType: "Money",
              fixedRateType: true,
              determinant: null,
              billingCycle: "Monthly",
              fixedBillingCycle: true,
              placementType: null,
              fixedPlacementType: false,
            },
            {
              uuid: uuidv4(),
              itemName: "Work Pass Processing Fee",
              description: null,
              rate: null,
              rateType: "Money",
              fixedRateType: true,
              determinant: null,
              billingCycle: "Per Application",
              fixedBillingCycle: true,
              placementType: null,
              fixedPlacementType: false,
            },
          ],
        },
        insuranceItems: [],
        terms: {
          hasConversionFee: true,
          items: [
            {
              uuid: uuidv4(),
              contractPeriodRange: "<=",
              contractPeriodComplete: "12 months",
              conversionRate: "Full talent search rate",
              fixedConversionRate: true,
              conversionRateType: "Money",
              determinant: "Based on talent search rate",
              fixedDeterminant: true,
              placementType: "Sourced by Jobline",
              fixedPlacementType: true,
              fixedItem: true,
            },
            {
              uuid: uuidv4(),
              contractPeriodRange: ">",
              contractPeriodComplete: "12 months",
              conversionRate: "50%",
              fixedConversionRate: true,
              conversionRateType: "Percentage",
              determinant: "of new offered salary",
              fixedDeterminant: true,
              placementType: "Sourced by Jobline",
              fixedPlacementType: true,
              fixedItem: true,
            },
            {
              uuid: uuidv4(),
              contractPeriodDescription: `If Contractor were originally sourced and referred by <company_name>`,
              contractPeriodRange: null,
              contractPeriodComplete: null,
              conversionRate: null,
              fixedConversionRate: true,
              conversionRateType: null,
              determinant: null,
              fixedDeterminant: true,
              placementType: "Referral",
              fixedPlacementType: true,
              fixedItem: true,
            },
          ],
          creditRule: null,
          prorationTerms: null,
          terminationNoticeInDays: 30,
          candidateOwnershipInMonths: 12,
        },
        placementFeeItems: [
          {
            ...BLANK_PAYROLL_PLACEMENT_FEE_ITEM,
            uuid: uuidv4(),
          },
        ],
        refundPolicy: null,
        refundPolicyOptions: {},
        hasUpfrontPlacementFee: false,
        entitlementItems: {
          include: true,
          fullEntitlement: FULL_ENTITLEMENT,
        },
        miscellaneousItems: [],
      },
      effectivePeriodInMonths: 24,
      terminationPeriodInDays: 30,
    },
  ],
  items: [
    "Dedicated HR Advisor",
    "Employee Onboarding",
    "Employee Relations",
    "Benefits Administration",
    "Monthly Payroll Management",
    "Cloud-based HR System",
    "Employee Separations",
    "Transparent and Digital Invoicing",
    "Real-time Reporting",
    "Filing of CPF and Payroll Tax",
    "Compliance to Statutory Requirements",
  ],
  categorisedItems: {
    contractManagement: [
      "Employee Onboarding",
      "Benefits Administration",
      "Employee Separations",
    ],
    payrollManagement: [
      "Monthly Payroll Management",
      "Filling of CPF and Payroll Tax",
      "Compliance to Statutory Requirements",
    ],
    billing: ["Transparent and Digital Invoicing", "Real-time Reporting"],
    advisory: [
      "Dedicated HR Advisor",
      "Employee Relations",
      "Cloud-based HR System",
    ],
  },
}

const getBasicPayrollManagedServicePlan = (companyName) => {
  const basicPayrollPlan = PAYROLL_MANAGED_SERVICES_PLANS.plans.filter(
    (plan) => plan.planName === "Basic"
  )[0]

  return basicPayrollPlan
}

const getCustomPayrollManagedServicePlan = (companyName) => {
  const customPayrollPlan = PAYROLL_MANAGED_SERVICES_PLANS.plans.filter(
    (plan) => plan.planName === "Custom"
  )[0]

  return customPayrollPlan
}

const WORK_PASS_PLAN = {
  planType: "Work Pass",
  planName: "Basic",
  rate: 600,
  rateType: "money",
  determinant: "per application",
  paymentTermsInDays: 14,
  effectivePeriodInMonths: 24,
  terminationPeriodInDays: 30,
  otherRates: {
    guaranteePeriodInMonths: 1,
  },
  items: [
    { label: "1 Appeal Submission per Applicant" },
    { label: "Work Pass Tracking System" },
    { label: "Certified HR Pros for Support and Advisory" },
    { label: "14 Days Payment Term" },
  ],
  addons: [
    {
      label: "Work Pass Renewal",
      agreementLabel: "Renewal of Work Pass and Dependent Pass",
      rateLabel: "$300.00",
      rate: 300,
      rateType: "money",
      determinant: "per applicant",
      showInView: true,
    },
    {
      label: "Work Pass Cancellation",
      agreementLabel:
        "Work Pass Cancellation and Issuance of 30 days Short Term Visit Pass",
      rateLabel: "$50.00",
      rate: 50,
      rateType: "money",
      determinant: "per applicant",
      showInView: true,
    },
    {
      label:
        "Work Pass related cost which includes Work Pass Application rate, Pass issuance / Multiple Journey Visa",
      agreementLabel:
        "Work Pass related cost which includes Work Pass Application rate, Pass issuance / Multiple Journey Visa",
      rateLabel: "As charged - Borne by <company_name>",
      rate: null,
      rateType: "money",
      determinant: "per applicant",
      showInView: false,
    },
    {
      label: "Medical Examination (as required by MOM)",
      agreementLabel: "Medical Examination (as required by MOM)",
      rateLabel: "Borne by <company_name>",
      rate: null,
      rateType: "money",
      determinant: null,
      showInView: false,
    },
    {
      label: "Application for HPB",
      agreementLabel:
        "Application for Verification of Vaccination Requirements (Health Promotion Board) – For Dependant Pass application",
      rateLabel: "$200.00",
      rate: 200,
      rateType: "money",
      determinant: "per applicant",
      showInView: true,
    },
    {
      label: "Update HPB on Particulars",
      agreementLabel: "Update HPB on new Travel document",
      rateLabel: "$50.00",
      rate: 50,
      rateType: "money",
      determinant: "per applicant",
      showInView: true,
    },
    {
      label: "Update HPB on Vaccination Record",
      agreementLabel: "Update HPB on future immunisation",
      rateLabel: "$50.00",
      rate: 50,
      rateType: "money",
      determinant: "per applicant per dose update",
      showInView: true,
    },
    {
      label:
        "Verification of Vaccination Application fee (Health Promotion Board)",
      agreementLabel:
        "Verification of Vaccination Application fee (Health Promotion Board)",
      rateLabel: "$35.00 - Borne by <company_name>",
      rate: 35,
      rateType: "money",
      determinant: "per applicant",
      showInView: false,
    },
  ],
}

const WORK_PASS_PLAN_SERVICE_FEE_ITEMS = [
  {
    agreementLabel:
      "S Pass / Employment Pass/ Dependent Application (includes 1 appeal submission if pass is rejected)",
    rateLabel:
      "First 3 application: $600.00; \n" +
      "3rd to 6th application: $500.00; \n" +
      "7th application onwards: $400.00\n",
    rate: 600,
    rateType: "money",
    determinant: "per applicant",
    showInView: false,
  },
  {
    label: "Work Pass Renewal",
    agreementLabel: "Renewal of Work Pass and Dependent Pass",
    rateLabel: "$300.00",
    rate: 300,
    rateType: "money",
    determinant: "per applicant",
    showInView: true,
  },
  {
    label: "Work Pass Cancellation",
    agreementLabel:
      "Work Pass Cancellation and Issuance of 30 days Short Term Visit Pass",
    rateLabel: "$50.00",
    rate: 50,
    rateType: "money",
    determinant: "per applicant",
    showInView: true,
  },
  {
    agreementLabel:
      "Work Pass related cost which includes Work Pass Application rate, Pass issuance / Multiple Journey Visa",
    rateLabel: "As charged - Borne by <company_name>",
    rate: null,
    rateType: "money",
    determinant: "per applicant",
    showInView: false,
  },
  {
    agreementLabel: "Medical Examination (as required by MOM)",
    rateLabel: "Borne by <company_name>",
    rate: null,
    rateType: "money",
    determinant: null,
    showInView: false,
  },
  {
    label: "Application for HPB",
    agreementLabel:
      "Application for Verification of Vaccination Requirements (Health Promotion Board) – For Dependant Pass application",
    rateLabel: "$200.00",
    rate: 200,
    rateType: "money",
    determinant: "per applicant",
    showInView: true,
  },
  {
    label: "Update HPB on Particulars",
    agreementLabel: "Update HPB on new Travel document",
    rateLabel: "$50.00",
    rate: 50,
    rateType: "money",
    determinant: "per applicant",
    showInView: true,
  },
  {
    label: "Update HPB on Vaccination Record",
    agreementLabel: "Update HPB on future immunisation",
    rateLabel: "$50.00",
    rate: 50,
    rateType: "money",
    determinant: "per applicant per dose update",
    showInView: true,
  },
  {
    agreementLabel:
      "Verification of Vaccination Application fee (Health Promotion Board)",
    rateLabel: "$35.00 - Borne by <company_name>",
    rate: 35,
    rateType: "money",
    determinant: "per applicant",
    showInView: false,
  },
]

const calculatePlanRate = (servicePlan, step1, step2) => {
  const totalSteps = +step1 + +step2
  let newRate

  if (totalSteps <= 2) {
    newRate = 12 + 2
  } else {
    newRate = 12 + 2 + (totalSteps - 2)
  }

  let items = servicePlan.items
  const months = 1 + (step1 - 1)
  const days = 30 + (step2 - 1) * 15

  items[0] = {
    label: `${months} ${pluralize("Month", months)} Guarantee Period`,
  }
  items[1] = { label: `${days} ${pluralize("Day", days)} Payment Term` }

  return { items: items, rate: newRate }
}

export {
  TALENT_SEARCH_PLANS,
  PAYROLL_MANAGED_SERVICES_PLANS,
  WORK_PASS_PLAN,
  WORK_PASS_PLAN_SERVICE_FEE_ITEMS,
  getBasicPayrollManagedServicePlan,
  getCustomPayrollManagedServicePlan,
  calculatePlanRate,
}
